import VleiWorkflowTask from '@/types/vlei-workflow-task'
import OorWorkflowTask from '@/types/oor-workflow-task'
import EcrWorkflowTask from '@/types/ecr-workflow-task'
import { WorkflowType } from '@/types/workflow'

/**
 * Defines the ordered, user-facing steps for each workflow type.
 *
 * Only these steps are used for progress calculation and stepper rendering.
 * Tasks not listed here do not affect workflow progress.
 */
export const WORKFLOW_STEPS_BY_TYPE: Record<WorkflowType, readonly string[]> = {
  [WorkflowType.LE_VLEI_PREREQ]: [
    VleiWorkflowTask.INTRODUCTION,
    VleiWorkflowTask.ORG_DOCUMENTATION,
    VleiWorkflowTask.PROPOSE_COORDINATOR,
    VleiWorkflowTask.QAR_ORG_RESEARCH,
    VleiWorkflowTask.IDENTITY_VERIFICATION,
    VleiWorkflowTask.ASSIGN_REPRESENTATIVES,
    VleiWorkflowTask.SCHEDULE_ISSUANCE_CEREMONY,
    VleiWorkflowTask.ISSUANCE_CEREMONY
  ],

  [WorkflowType.OOR_VLEI_PREREQ]: [
    OorWorkflowTask.INTRODUCTION,
    OorWorkflowTask.PROPOSE_RECIPIENTS,
    OorWorkflowTask.QAR_ORG_VERIFICATION,
    OorWorkflowTask.IDENTITY_VERIFICATION,
    OorWorkflowTask.SCHEDULE_ISSUANCE_CEREMONY,
    OorWorkflowTask.ISSUANCE_CEREMONY
  ],

  [WorkflowType.ECR_VLEI_PREREQ]: [
    EcrWorkflowTask.INTRODUCTION,
    EcrWorkflowTask.PROPOSE_RECIPIENTS,
    EcrWorkflowTask.IDENTITY_VERIFICATION,
    EcrWorkflowTask.SCHEDULE_ISSUANCE_CEREMONY,
    EcrWorkflowTask.ISSUANCE_CEREMONY
  ]
} as const
